<template>
  <div class="bg-white shadow-inner text-black flex flex-col flex-shrink">
    <div class="flex flex-col sidenav p-5" :class="{'collapsed': collapsed}">
      <div class="py-5 px-10 flex justify-center">
        <a href="/">
          <img :src="company.logoUrl">
        </a>
      </div>
      <ul class="list-none">
        <li>
          <a href="/" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="chalkboard-teacher" />
              </div>
              <span>Mentoring Gateway</span>
            </div>
          </a>
        </li>
        <li>
          <a href="/assignments" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="list" />
              </div>
              <span>My Assignments</span>
            </div>
          </a>
        </li>
        <li>
          <a href="https://forums.peerlinkpro.com/" class="no-underline" target="_blank">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="comments" />
              </div>
              <span>Discussion Forum</span>
            </div>
          </a>
        </li>
        <li v-if="hasRole('Mentor') && !hasRole('Consultant')">
          <a href="/mentor/index" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="users" />
              </div>
              <span>My Mentees/Groups</span>
            </div>
          </a>
        </li>
        <li v-if="hasRole('Consultant')">
          <a href="/mentor/index" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="users" />
              </div>
              <span>Communities/Groups</span>
            </div>
          </a>
        </li>
        <li v-if="!hasRole('Mentee')">
          <a href="/assignment-admin" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="tasks" />
              </div>
              <span>Manage Assignments</span>
            </div>
          </a>
        </li>

        <li v-if="hasRole('System Administrator')">
          <a href="/admin" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="user-shield" />
              </div>
              <span>Admin</span>
            </div>
          </a>
        </li>

        <li v-if="hasRole('Mentor') || hasRole('Consultant') || hasRole('System Administrator')">
          <a href="/reports" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="file-alt" />
              </div>
              <span>Reports/Exports</span>
            </div>
          </a>
        </li>

        <li>
          <a href="/resources" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="file" />
              </div>
              <span>Resources</span>
            </div>
          </a>
        </li>
        <li>
          <a href="/announcements" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="bullhorn" />
              </div>
              <span>Announcements</span>
            </div>
          </a>
        </li>
        <li>
          <a href="/calendar" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="calendar" />
              </div>
              <span>Calendar</span>
            </div>
          </a>
        </li>

        <li v-if="hasRole('Mentee') || hasRole('Mentor')">
          <a href="/contact" class="no-underline">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="envelope" />
              </div>
              <span>Contact</span>
            </div>
          </a>
        </li>

        <li v-for="navLink in navLinks" :key="navLink.id">
          <a :href="navLink.url" class="no-underline" :target="navLink.openInNewTab ? '_blank' : '_self'">
            <div class="flex items-center text-left py-2">
              <div class="w-10 text-center">
                <d-icon size="sm" icon="link" />
              </div>
              <span>{{ navLink.title }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from 'axios';

  export default {
    parent: true,

    data: () => ({
      navLinks: [],
    }),

    computed: {
      ...mapGetters('d2Auth', ['profile', 'hasRole', 'hasAnyRole', 'company']),
      ...mapGetters('sidenav', ['collapsed']),
    },
    mounted() {
      this.getNavLinks();
    },
    methods: {
      async getNavLinks() {
        const { data } = await axios.get('/api/nav-links');
        this.navLinks = data;
      },
    },
  };
</script>

<style scoped>
  .sidenav.collapsed {
    margin-left: -250px;
  }

  .sidenav {
    transition: margin-left 250ms ease-out, transform 250ms ease-out;
    width: 250px;
  }
</style>